import { render, staticRenderFns } from "./clearing_details.vue?vue&type=template&id=057dbf7e&scoped=true"
import script from "./clearing_details.vue?vue&type=script&lang=js"
export * from "./clearing_details.vue?vue&type=script&lang=js"
import style0 from "./clearing_details.vue?vue&type=style&index=0&id=057dbf7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057dbf7e",
  null
  
)

export default component.exports